/*global define:false*/
define('plugins/textbox/view.js',['pluginBaseView'],
    function (PluginBaseView) {
        'use strict';

        return PluginBaseView.extend({
        });

    });

